import React from 'react'
import type { PresentationBlockProps } from '../..'
import compareBlockProps from '../../util/compareBlockProps'
import { InlineEditableHtml } from '../../inlineEditable'
import classnames from 'classnames'
import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

const useStyles = makeStyles<Theme, PresentationBlockProps>(
  (_theme: Theme) => {
    return {
      root: {},
      content: (props, color = props.block.fields?.color) => ({
        '& h1, & h2, & h3, & p, & ol, & ul': {
          color: `${color} !important`
        }
      })
    }
  },
  { name: 'TextBlock' }
)

function TextBlock(props: PresentationBlockProps) {
  const { block, WrapperComponent, isSettings, blockPrefix, isEditable, presetColors, setFieldValue, submitForm } =
    props

  const classes = useStyles(props)

  const { fields } = block
  const customColor = props.block.fields?.color

  const handleEditField = (field: string, content: string) => {
    setFieldValue(`${blockPrefix}.${field}`, content)
    submitForm()
  }

  return (
    <WrapperComponent {...props}>
      <InlineEditableHtml
        classes={{
          root: classnames({
            [classes.content]: !!customColor
          })
        }}
        placeholderButtonText={'Add Text'}
        isEditable={isEditable}
        isSettings={isSettings}
        handleEdit={(content) => handleEditField('fields.content', content)}
        content={fields.content}
        presetColors={presetColors}
        fieldKey={`${blockPrefix}.fields.content`}
      />
    </WrapperComponent>
  )
}

export default React.memo(TextBlock, (prevProps, nextProps) => {
  return compareBlockProps(prevProps, nextProps)
})
